<template>
  <div class="main_error">
    <h1 class="h1_error">{{$t('error')}}</h1>
    <div v-if="$route.params.msg">
    <h5>Detail: {{ $route.params.msg }}</h5>
    </div>
    <li class="link-back">
      <router-link v-if="$route.params.route" class="nav-link" :to="{name: $route.params.route}">{{$t('go_back')}}</router-link>
      <router-link v-else class="nav-link" to="/">{{$t('go_back')}}</router-link>
    </li>
    <img class="error-invoxia" src="../assets/invoxia.jpg" alt="invoxia" />
  </div>
</template>
<script>
import "../assets/scss/style.scss";
export default {
  name: "ErrorServer"
};
</script>